import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const scrollToForm = () => {
  const el = document.getElementById("rezervace");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const links = [
    { label: "Příběh", id: "pribeh" },
    { label: "Balíčky", id: "nabidka" },
    { label: "Pobočky", id: "pobocky" },
    { label: "FAQ", id: "faq" },
    { label: "Rezervace", id: "rezervace" },
  ];

  const handleMobileClick = (id) => {
    setOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-9 sm:top-10 inset-x-0 z-50 transition-all duration-500 ${
        scrolled || open
          ? "bg-black/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 h-16 md:h-20 flex items-center justify-between gap-3">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={() => setOpen(false)}
          className="flex items-center gap-2.5 md:gap-3 group min-w-0"
        >
          <div className="relative shrink-0">
            <div className="w-8 h-8 md:w-9 md:h-9 border border-[#D4AF37]/50 flex items-center justify-center">
              <span className="font-display text-[#D4AF37] text-lg md:text-xl leading-none">C</span>
            </div>
          </div>
          <div className="leading-none min-w-0">
            <div className="font-display text-lg md:text-xl tracking-wide text-white truncate">CarSpa</div>
            <div className="text-[9px] md:text-[10px] tracking-[0.3em] md:tracking-[0.35em] uppercase text-[#D4AF37]/80 truncate">Prémiový Detailing</div>
          </div>
        </a>

        {/* Desktop links */}
        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className="text-xs tracking-[0.25em] uppercase text-zinc-300 hover:text-[#D4AF37] lux-link transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={scrollToForm}
            data-testid="nav-cta-button"
            className="btn-gold bg-[#D4AF37] hover:bg-[#F0C846] text-black px-3 md:px-5 py-2.5 md:py-3 text-[10px] md:text-[11px] tracking-[0.2em] md:tracking-[0.25em] uppercase font-semibold transition-colors whitespace-nowrap"
          >
            <span className="hidden sm:inline">Zajistit voucher</span>
            <span className="sm:hidden">Voucher</span>
          </button>

          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label={open ? "Zavřít menu" : "Otevřít menu"}
            aria-expanded={open}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white hover:text-[#D4AF37] transition-colors"
          >
            {open ? <X size={22} strokeWidth={1.3} /> : <Menu size={22} strokeWidth={1.3} />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ease-out ${
          open ? "max-h-[80vh]" : "max-h-0"
        }`}
        data-testid="nav-mobile-drawer"
      >
        <nav className="px-6 pb-8 pt-4 flex flex-col divide-y divide-white/5 border-t border-white/5 bg-black/60 backdrop-blur-xl">
          {links.map((l) => (
            <button
              key={l.id}
              type="button"
              onClick={() => handleMobileClick(l.id)}
              data-testid={`nav-mobile-link-${l.id}`}
              className="text-left py-4 text-sm tracking-[0.25em] uppercase text-zinc-200 hover:text-[#D4AF37] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Nav;
